import { React, Fragment, useState } from "react";
import { Modal } from "antd";
import { epochToDate } from '../../shared/functions/toDateTime'
import {
  FILTER_STATUS_FALSE,
  FILTER_STATUS_TRUE

} from "../ErrorLog/constants";
import {
  Grid,
  Typography,
  Paper,
  Box,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText
} from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import { useFirestoreConnect } from 'react-redux-firebase';
import { useSelector } from "react-redux";
import { firestore } from "../../config/firebaseConfig";




export default function ErrorLogDetails({
  visible,
  handle2Cancel,
  error_log,
  erro_log,
  values
}) {
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState("");
  const theme = useTheme();
  console.log(error_log.Status)

  const status = [
    FILTER_STATUS_FALSE,
    FILTER_STATUS_TRUE,
  ]


  const handleClickToOpen = () => {
    setOpen(true);
  };

  const handleToClose = () => {
    setOpen(false);
  };

  useFirestoreConnect(() => [
    {
      collection: "erro_log",
      doc: "correct_log",
      storeAs: "erro_log"
    }
  ])

  const CorrectError = useSelector(state => state.firestore.ordered["erro_log"])

  console.log(CorrectError)
  // console.log(comment)
  // console.log(erro_log)
  // console.log(error_log)
  // console.log(error_log.id)



  const handleToComment = async (erro_log, ErrorLog, id) => {
    await firestore.collection("erro_log").doc(error_log.id).set({ comment, Status: true }, { merge: true });
    handleToClose();
  }


  return (
    <>
      <Modal
        title="Details d'erreur"
        visible={visible}
        footer={[]}
        onCancel={handle2Cancel}
        width={800}
        zIndex={theme.zIndex.drawer + 2}
      >
          <Paper
            style={{
              padding: 5,
              paddingLeft: 20,
              paddingRight: 20,
              paddingBottom: 2,
              marginTop: 10,
            }}
          >
            <Grid container spacing={4}>
              <Grid container justify="space-between" item>
                <Grid item>
                  <Typography variant="overline"> Date D'Erreur : </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="overline"> {error_log.CreateAt && epochToDate(error_log.CreateAt)} </Typography>
                </Grid>
              </Grid>
              <Grid container justify="space-between" item>
                <Grid item>
                  <Typography variant="overline"> Message D'Erreur : </Typography>
                </Grid>
                <Grid item >
                  <Typography variant="overline"> {error_log.ErrorMessage} </Typography>
                </Grid>
              </Grid>
              <Grid container justify="space-between" item>
                <Grid item>
                  <Typography variant="overline"> Suivie de  l'Erreur : </Typography>
                </Grid>
                <Grid item>
                  <Box style={{ maxWidth: 500 }}>
                    <Typography variant="caption"> {error_log.ErrorTrack} </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid container justify="space-between" item>
                <Grid item>
                  <Typography variant="overline"> Commentaire : </Typography>
                </Grid>
                <Grid item >
                  <Typography variant="overline"> {error_log.comment} </Typography>
                </Grid>
              </Grid>
              <Grid container justify="space-between" item>
                <Grid item>
                  <Typography variant="overline"> Status D'Erreur : </Typography>
                </Grid>
                <Grid item>
                  {
                    status && status ?
                      <Button variant="contained" color="primary" onClick={handleClickToOpen}> Terminé  </Button>
                      :
                      <Button variant="contained" color="secondary">  En Attente </Button>
                  }
                </Grid>
                <Dialog open={open} onClose={handleToClose} fullWidth>
                  <DialogTitle>Ajouter une commentaire </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                        <TextField
                          label="Commentaire"
                          variant="outlined"
                          fullWidth
                          value={comment}
                          onChange={(e) => setComment(e.currentTarget.value)}
                        />
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Grid item container spacing={2} justify="flex-end">
                      <Grid>
                        <Button onClick={handleToClose}
                          color="secondary" autoFocus>
                          Annuler
                        </Button>
                      </Grid>
                      <Grid>
                        <Button onClick={handleToComment}
                          color="primary" autoFocus >
                          Valider
                        </Button>
                      </Grid>
                    </Grid>
                  </DialogActions>
                </Dialog>
              </Grid>
            </Grid>
          </Paper>

      </Modal>

    </>
  );
}
